(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loverse-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lve-collection')) {
    /**
     * Loverse collection page behaviour:
     * - Hub: "See all N styles" opens the list on the same page.
     * - "Show 12 more" reveals the next batch; the server sends chunks of 60 and
     *   the next chunk is fetched through the Section Rendering API when needed.
     * - `?shown=N` stays in the address (history.replaceState); after Back from a
     *   style the list reopens with the same count. The scroll comes back on
     *   every Back/Forward load, with or without `?shown`.
     * - One chunk request at a time; "Show 12 more" is busy while a restore runs.
     * - The collection description collapses to two lines with "Read more".
     * - Events: collection_see_all_open and collection_show_more, plus the GA4
     *   view_item_list (shown styles) and select_item (card tap). Tap events of
     *   cards and circles come from their data-lve-event attributes.
     */
    class LveCollection extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.handle = this.dataset.collection || '';
        this.scrollKey = `lve-coll-scroll:${location.pathname}`;

        this.setupDescription();
        this.list = this.querySelector('[data-lve-paging]');
        const restoring = this.list ? this.setupList() : null;

        this.addEventListener('click', this.onClick);
        window.addEventListener('pagehide', this.saveScroll);

        const shown = this.shownCards();
        this.trackView(shown);
        if (restoring) {
          // Styles brought back from `?shown` count as viewed too; the scroll
          // comes back once they are in place.
          restoring.then(() => {
            const tracked = new Set(shown);
            this.trackView(this.shownCards().filter((card) => !tracked.has(card)));
            this.restoreScroll();
          });
        } else {
          this.restoreScroll();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        window.removeEventListener('pagehide', this.saveScroll);
      }

      /* ---------- list ---------- */

      setupList() {
        const data = this.list.dataset;
        this.grid = this.list.querySelector('[data-lve-grid]');
        this.box = this.list.querySelector('[data-lve-allbox]');
        this.openLink = this.list.querySelector('[data-lve-all-open]');
        this.foot = this.list.querySelector('[data-lve-foot]');
        this.more = this.list.querySelector('[data-lve-more]');
        this.seenEl = this.list.querySelector('[data-lve-seen]');
        this.status = this.list.querySelector('[data-lve-status]');
        this.total = Number(data.total) || 0;
        this.offset = Number(data.offset) || 0;
        this.head = Number(data.head) || 0;
        this.first = Number(data.first) || 12;
        this.batch = Number(data.batch) || 12;
        this.nextUrl = data.nextUrl || '';
        this.closed = data.closed !== undefined;
        this.texts = {};
        const texts = this.list.querySelector('template[data-lve-texts]');
        texts?.content.querySelectorAll('[data-k]').forEach((el) => {
          this.texts[el.dataset.k] = el.textContent.trim();
        });

        for (const item of this.items()) item.classList.remove('lve-later');

        const wanted = Number(new URL(location.href).searchParams.get('shown')) || 0;
        const byHash = Boolean(this.closed && this.box && location.hash === `#${this.box.id}`);
        if (this.closed && wanted <= this.offset + this.head && !byHash) {
          this.visible = 0;
          this.render();
          return null;
        }
        if (this.closed) this.open();
        this.visible = Math.min(this.items().length, Math.max(this.first, wanted - this.offset - this.head));
        this.render();
        if (byHash && !wanted) {
          // Opened by a link to #lve-all (for example in a new tab): the same as a tap on "See all".
          this.writeUrl();
          this.push({ event: 'collection_see_all_open', collection: this.handle });
        }
        return wanted > this.seen() ? this.restore(wanted) : null;
      }

      items() {
        return this.grid ? Array.from(this.grid.querySelectorAll(':scope > [data-lve-item]')) : [];
      }

      seen() {
        return this.offset + this.head + this.visible;
      }

      open() {
        this.closed = false;
        this.box?.classList.add('is-open');
        if (this.openLink) this.openLink.hidden = true;
      }

      render() {
        this.items().forEach((item, index) => {
          item.hidden = index >= this.visible;
        });
        if (!this.foot) return;
        const seen = this.seen();
        const left = this.total - seen;
        this.foot.hidden = this.closed || left <= 0;
        if (left <= 0) return;
        const next = Math.min(this.batch, left);
        if (this.more) this.more.textContent = this.texts[`more-${next}`] || this.more.textContent.trim();
        if (this.seenEl) this.seenEl.textContent = this.seenText(seen);
      }

      seenText(seen) {
        const template = this.texts.seen || '';
        return template.replace('__SEEN__', String(seen)).replace('__TOTAL__', String(this.total));
      }

      writeUrl() {
        const url = new URL(location.href);
        url.searchParams.set('shown', String(this.seen()));
        history.replaceState(history.state, '', url);
      }

      /** Loads the next chunk of styles from the server, hidden until revealed. */
      async loadMore() {
        if (!this.nextUrl) return false;
        const url = new URL(this.nextUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId || '');
        url.searchParams.delete('shown');
        const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-lve-paging]');
        const grid = fresh?.querySelector('[data-lve-grid]');
        if (!fresh || !grid) throw new Error('missing list');
        const fetched = Array.from(grid.querySelectorAll(':scope > [data-lve-item]'));
        // Safety net: never add a style that is already in the grid.
        const have = new Set(this.items().map((item) => item.dataset.lveIndex));
        const items = fetched
          .filter((item) => !have.has(item.dataset.lveIndex))
          .map((item) => {
            const copy = document.importNode(item, true);
            copy.classList.remove('lve-later');
            copy.hidden = true;
            return copy;
          });
        this.grid.append(...items);
        this.nextUrl = fresh.dataset.nextUrl || '';
        return fetched.length > 0;
      }

      /** One chunk request at a time: a second caller waits for the request in flight. */
      loadNext() {
        if (!this.loading) {
          this.loading = this.loadMore().finally(() => {
            this.loading = null;
          });
        }
        return this.loading;
      }

      /** Shows `count` list styles, loading chunks as needed. */
      async showUpTo(count) {
        while (this.items().length < count && this.nextUrl) {
          if (!(await this.loadNext())) break;
        }
        this.visible = Math.min(count, this.items().length);
        this.render();
        this.writeUrl();
      }

      /** Back on `?shown=N`: show the same count. "Show 12 more" waits until it is done. */
      async restore(wanted) {
        this.more?.setAttribute('aria-busy', 'true');
        try {
          await this.showUpTo(wanted - this.offset - this.head);
        } catch {
          // Keep what is shown; the button still works.
        } finally {
          this.more?.removeAttribute('aria-busy');
        }
      }

      scroller() {
        const page = window.matchMedia('(min-width: 990px)').matches && document.querySelector('.page-wrapper');
        return page || document.scrollingElement || document.documentElement;
      }

      saveScroll = () => {
        try {
          sessionStorage.setItem(this.scrollKey, String(this.scroller().scrollTop));
        } catch {
          // Storage blocked: Back starts where the browser puts it.
        }
      };

      /**
       * After Back (or Forward) to this page, put the shopper where they left,
       * with or without `?shown`. From 990 px `.page-wrapper` is the scroll
       * container, and the browser does not restore an inner container itself.
       */
      restoreScroll() {
        const navigation = performance.getEntriesByType?.('navigation')[0];
        if (navigation?.type !== 'back_forward') return;
        let saved = 0;
        try {
          saved = Number(sessionStorage.getItem(this.scrollKey)) || 0;
        } catch {
          return;
        }
        if (!saved) return;
        requestAnimationFrame(() => this.scroller().scrollTo({ top: saved, behavior: 'instant' }));
      }

      openAll() {
        this.open();
        this.visible = Math.min(this.first, this.items().length);
        this.render();
        this.writeUrl();
        this.push({ event: 'collection_see_all_open', collection: this.handle });
        this.trackView(this.cardsIn(this.items().slice(0, this.visible)));
        this.list.querySelector('[data-lve-all-title]')?.focus({ preventScroll: true });
      }

      async showMore(button) {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        const firstNew = this.visible;
        try {
          await this.showUpTo(this.visible + this.batch);
        } catch {
          button.removeAttribute('aria-busy');
          if (this.nextUrl) window.location.href = this.nextUrl;
          return;
        }
        button.removeAttribute('aria-busy');
        const fresh = this.items().slice(firstNew, this.visible);
        if (this.status) this.status.textContent = this.seenText(this.seen());
        this.push({ event: 'collection_show_more', collection: this.handle, shown: this.seen() });
        this.trackView(this.cardsIn(fresh));
        // Keyboard and screen-reader users continue from the first new style.
        fresh[0]?.querySelector('a')?.focus({ preventScroll: true });
      }

      /* ---------- description ---------- */

      setupDescription() {
        const body = this.querySelector('[data-lve-desc-body]');
        const button = this.querySelector('[data-lve-desc-more]');
        if (!body || !button) return;
        body.classList.add('is-clamped');
        if (body.scrollHeight - body.clientHeight > 2) {
          button.hidden = false;
        } else {
          body.classList.remove('is-clamped');
        }
      }

      expandDescription(button) {
        const body = this.querySelector('[data-lve-desc-body]');
        if (!body) return;
        body.classList.remove('is-clamped');
        button.setAttribute('aria-expanded', 'true');
        button.hidden = true;
        body.tabIndex = -1;
        body.focus({ preventScroll: true });
      }

      /* ---------- events ---------- */

      onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

        const openLink = target.closest('[data-lve-all-open]');
        if (openLink && !modified) {
          event.preventDefault();
          this.openAll();
          return;
        }
        const more = target.closest('[data-lve-more]');
        if (more && this.list?.contains(more)) {
          event.preventDefault();
          this.showMore(more);
          return;
        }
        const descMore = target.closest('[data-lve-desc-more]');
        if (descMore) {
          this.expandDescription(descMore);
          return;
        }
        const card = target.closest('a.lve-pcard');
        if (card) {
          this.selectItem(card);
          this.saveScroll();
        }
      };

      push(payload) {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(payload);
        } catch {
          // Analytics must never break the page.
        }
      }

      cardsIn(cells) {
        return cells.map((cell) => cell.querySelector('a.lve-pcard')).filter(Boolean);
      }

      shownCards() {
        return Array.from(this.querySelectorAll('a.lve-pcard')).filter((card) => card.getClientRects().length > 0);
      }

      item(card) {
        const index = Number(card.closest('[data-lve-index]')?.dataset.lveIndex) || undefined;
        return {
          item_id: card.dataset.lveItemId,
          item_name: card.dataset.lveItemName,
          price: Number(card.dataset.lveItemPrice) || 0,
          index,
          item_list_id: this.handle,
          item_list_name: card.dataset.lveList || 'best_seller',
        };
      }

      ecommerce(items) {
        return {
          currency: this.dataset.currency || undefined,
          item_list_id: this.handle,
          item_list_name: this.dataset.listName || this.handle,
          items,
        };
      }

      trackView(cards) {
        if (!cards.length) return;
        this.push({ ecommerce: null });
        this.push({ event: 'view_item_list', ecommerce: this.ecommerce(cards.map((card) => this.item(card))) });
      }

      selectItem(card) {
        this.push({ ecommerce: null });
        this.push({ event: 'select_item', ecommerce: this.ecommerce([this.item(card)]) });
      }
    }

    customElements.define('lve-collection', LveCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loverse-home-trustpilot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lve-tp-slider')) {
    customElements.define(
      'lve-tp-slider',
      class extends HTMLElement {
        static SECONDS = 6;
        static RESUME_AFTER_MS = 3000;

        connectedCallback() {
          this.track = this.querySelector('.lve-hb-tp__track');
          this.dots = Array.from(this.querySelectorAll('.lve-hb-tp__dots button'));
          if (!this.track || this.dots.length < 2) return;

          this.slides = Array.from(this.track.children);
          this.index = 0;
          this.hold = false;
          this.calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.phone = window.matchMedia('(max-width: 1023px)');

          this.dots.forEach((dot, n) => dot.addEventListener('click', () => this.go(n, true)));

          let settle;
          this.track.addEventListener(
            'scroll',
            () => {
              clearTimeout(settle);
              settle = setTimeout(() => this.syncFromScroll(), 120);
            },
            { passive: true }
          );

          const pause = () => {
            clearTimeout(this.resumeTimer);
            this.hold = true;
          };
          const resume = () => {
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(() => (this.hold = false), this.constructor.RESUME_AFTER_MS);
          };
          ['touchstart', 'pointerenter', 'focusin'].forEach((name) => this.addEventListener(name, pause, { passive: true }));
          ['touchend', 'touchcancel', 'pointerleave', 'focusout'].forEach((name) =>
            this.addEventListener(name, resume, { passive: true })
          );

          if (!this.calm) {
            this.timer = setInterval(() => {
              if (this.phone.matches && !this.hold && !document.hidden) this.go(this.index + 1, false);
            }, this.constructor.SECONDS * 1000);
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          clearTimeout(this.resumeTimer);
        }

        step() {
          return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
        }

        go(n, fromUser) {
          this.index = (n + this.slides.length) % this.slides.length;
          const behavior = this.calm ? 'auto' : 'smooth';
          this.track.scrollTo({ left: this.index * this.step(), behavior });
          this.paint();
          if (fromUser) {
            this.hold = true;
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(() => (this.hold = false), this.constructor.RESUME_AFTER_MS);
          }
        }

        syncFromScroll() {
          const step = this.step();
          if (step > 0) {
            this.index = Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / step));
            this.paint();
          }
        }

        paint() {
          this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
